import React, { useEffect, useState } from "react";
import liff from "@line/liff";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  margin: 0 auto;
  width: 100%;
  max-width: 100vw; // Ensures that the width does not exceed the viewport width
  height: 100vh; // Use the viewport height to limit the container height
  box-sizing: border-box; // Include padding in the height calculation
  overflow-y: auto; // Allows vertical scrolling within the container if necessary
`;

const LiffInit = ({ children }) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const initializeLiff = async () => {
      try {
        await liff.init({ liffId: "2004697545-k46Q3GE3" });
        if (liff.isLoggedIn()) {
          const userProfile = await liff.getProfile();
          setProfile(userProfile);
        } else {
          liff.login();
        }
      } catch (err) {
        console.error("LIFF Initialization failed", err);
      }
    };

    initializeLiff();
  }, []);
  const ProfileContainer = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
  `;

  const ProfileImage = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
  `;

  const ProfileName = styled.p`
    margin: 0;
    font-size: 14px;
  `;
  return (
    <div className="App">
      <Container>
        {profile && (
          <ProfileContainer>
            <ProfileImage
              src={profile.pictureUrl}
              alt="profileUrl"
              loading="lazy"
            />
            <ProfileName data-testid="displayName">
              {profile.displayName}
            </ProfileName>
          </ProfileContainer>
        )}
        <h1>SWIPY收款狀態查詢</h1>
        {children}
      </Container>
    </div>
  );
};

export default LiffInit;
